import { render, staticRenderFns } from "./input-number.vue?vue&type=template&id=34f19b94&scoped=true&"
import script from "./input-number.ts?vue&type=script&lang=ts&"
export * from "./input-number.ts?vue&type=script&lang=ts&"
import style0 from "./input-number.scss?vue&type=style&index=0&id=34f19b94&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f19b94",
  null
  
)

export default component.exports